module.exports = __webpack_public_path__ + "img/la-muerte-de-belle.ceac9a2f.jpg";